'use client';

import { type ReactNode, createContext, use } from 'react';

type PortalContainerProviderProps = {
  children: ReactNode;
  container: HTMLElement;
};

const PortalContainerContext = createContext<HTMLElement | undefined>(
  undefined,
);

export const PortalContainerProvider = ({
  children,
  container,
}: PortalContainerProviderProps) => {
  return (
    <PortalContainerContext.Provider value={container}>
      {children}
    </PortalContainerContext.Provider>
  );
};

export const usePortalContainer = (): HTMLElement | undefined => {
  return use(PortalContainerContext);
};
